<template>
  <v-container class="ma-0 pa-0">
    <v-select
      v-model="selectedLocationId"
      :items="locationOptions"
      item-text="name"
      item-value="locationId"
      label="Location"
      clearable
      @change="selectLocation"
    />
    <v-select
      v-model="rack"
      :items="racks"
      label="Rack"
      :disabled="!!selectedLocationId"
    />
    <v-select
      v-model="row"
      :items="rows"
      label="Row"
      :disabled="!!selectedLocationId || !rack"
    />
    <v-select
      v-model="shelf"
      :items="shelves"
      label="Shelf"
      :disabled="!!selectedLocationId || (!row && !rack)"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'WarehouseLocationSearchComponent',
  props: {
    locationId: {
      type: String,
      default: null,
    },
    warehouseId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    locations: [],
    selectedLocationId: null,
    racks: [],
    rack: null,
    rows: [],
    row: null,
    shelves: [],
    shelf: null,
    model: {
      rack: null,
      row: null,
      shelf: null,
    },
  }),
  computed: {
    locationOptions() {
      if (this.selectedLocationId
        && !this.locations.some((location) => location.locationId === this.selectedLocationId)) {
        return [{ locationId: this.selectedLocationId, name: this.selectedLocationId },
          ...this.locations];
      }
      return this.locations;
    },
  },
  watch: {
    warehouseId() {
      this.selectedLocationId = null;
      this.rack = null;
      this.row = null;
      this.shelf = null;
      this.getLocationParts();
    },
    rack(val) {
      this.rows = this.locations.filter((x) => x.rack === val).map((x) => x.row);
      this.model.rack = val;
      this.emitLocation();
    },
    row(val) {
      this.shelves = this.locations.filter((x) => x.rack === this.rack && x.row === val)
        .map((x) => x.shelf);
      this.model.row = val;
      this.emitLocation();
    },
    shelf(val) {
      this.model.shelf = val;
      this.emitLocation();
    },
  },
  created() {
    this.selectedLocationId = this.locationId;
  },
  mounted() {
    this.getLocationParts();
  },
  methods: {
    ...mapActions('apiClient', ['get']),
    selectLocation() {
      this.rack = null;
      this.row = null;
      this.shelf = null;
      this.model = { rack: null, row: null, shelf: null };
      this.emitLocation();
    },
    emitLocation() {
      const location = this.selectedLocationId
        ? { locationId: this.selectedLocationId } : { ...this.model };
      this.$emit('onSetModel', location);
    },
    getLocationParts() {
      this.get({
        url: '/locations',
        params: {
          warehouseId: this.warehouseId,
          activeOnly: true,
        },
      }).then(
        (response) => {
          this.locations = response.data;

          const racks = new Set();
          response.data.filter((e) => e.rack).forEach((e) => racks.add(e.rack));
          this.racks = Array.from(racks);
        },
      );
    },
  },
};
</script>
